import React from 'react';
import { Box, Typography } from '@mui/material';
import { buildInfo } from '../config/buildInfo';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: 3,
        backgroundColor: '#ffffff',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontSize: '0.75rem',
        }}
      >
        v{buildInfo.version} Build {buildInfo.buildNumber}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontSize: '0.75rem',
        }}
      >
        Copyright © {currentYear} Neos. Todos los derechos reservados.
      </Typography>
    </Box>
  );
};

export default Footer;
